import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        contractCurrentCompany: [
          entity?.parameters?.contractCurrentCompany || null,
          [Validators.required],
        ],
        contractCurrentCompanyAddressStreet: [
          entity?.parameters?.contractCurrentCompanyAddressStreet || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        contractCurrentCompanyAddressZipCode: [
          entity?.parameters?.contractCurrentCompanyAddressZipCode || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        contractCurrentCompanyAddressCity: [
          entity?.parameters?.contractCurrentCompanyAddressCity || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        contractCurrentCompanyPhone: [
          entity?.parameters?.contractCurrentCompanyPhone || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        contractCurrentCompanyEmail: [
          entity?.parameters?.contractCurrentCompanyEmail || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        transferReason: [
          entity?.parameters?.transferReason || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        transferEntryFeesAmount: [
          entity?.parameters?.transferEntryFeesAmount || 0,
          [Validators.required],
        ],
        lastRecordAmount: [
          entity?.parameters?.lastRecordAmount || null,
          [Validators.required],
        ],
        cumulVersementsAncienContrat: [
          entity?.parameters?.cumulVersementsAncienContrat || null,
          [
            entity?.parameters?.operation === 'TRANSFER'
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        lastRecordDate: [
          entity?.parameters?.lastRecordDate || null,
          [Validators.required],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    return this.form.value.products;
  }
}
